import { IPermissionValidator, ModulePermissionValidator } from 'helpers';
import { UserModule } from 'models/user/sso';
import {
    CertifiedPage,
    CompanyManager,
    ContactPage,
    ContractsPage,
    DashboardMenu,
    DetailsRma,
    FinalCustomerManager,
    FindAnAssistancePage,
    NewRma,
    NewRmaSummary,
    RepairCenter,
    RepairCenterPage,
    RmaDetails,
    SendOrderBudget,
    SolutionsPage,
    SpareParts,
    UserManager,
    WarrantyConsultPage,
    InstructionsPage,
    HslPage,
    HomePage
} from 'pages';
import SparePartsPage from 'pages/identity/sparePartsPage';
import MaintenanceReportPage from 'pages/maintenanceReport/maintenanceReportPage';
import NewMaintenanceReport from 'pages/maintenanceReport/newMaintenanceReport/newMaintenanceReport';
import MaintenanceReportDetails from 'pages/maintenanceReport/maintenanceReportDetails';
import Overview from 'pages/manual/acordion/overview';
import TesteManual from 'pages/manual/manual';
import OrdersDetailSelected from 'pages/spareParts/OrdersDetails';
import { SparePartsChat } from 'pages/spareParts/components/tabs';
import ShoppingCart from 'pages/spareParts/components/tabs/shoppingCart/shoppingCart';
import NewCompany from 'pages/userManager/tabs/customerManager/newCompany';
import InventoryDetails from 'pages/hsl/inventory/inventoryDetails';
import DeliverySearch from 'pages/hsl/inventory/delivery/deliverySearch';
import DeliveryDetails from 'pages/hsl/inventory/delivery/deliveryDetails/deliveryDetails';
import NewDelivery from 'pages/hsl/inventory/delivery/newDelivery/newDelivery';
import NewGuia from 'pages/hsl/inventory/delivery/newDelivery/newGuia';
import Repair from 'pages/hsl/repair/execute-repair/executeRepair';
import PendingItems from 'pages/hsl/inventory/delivery/pendingItems/pendingItems';
import RmaManufatura from 'pages/rmaManufatura/rmaManufacturing';
import NewRmaManufatura from 'pages/rmaManufatura/components/newRma/newRmaManufacturing';
import NewRmaSummaryManufatura from 'pages/rmaManufatura/components/newRma/NewRmaSummaryManufacturing';
import RmaManufaturaDetails from 'pages/rmaManufatura/rmaManufacturingDetails';
import SendOrderBudgetManufatura from 'pages/rmaManufatura/components/accordion/workOrders/sendBudgetManufacturing';
import SystemManager from 'pages/systemManager/systemManager';
import { BslbrPage } from 'pages/bslbr';
import InventoryDetails_Br from 'pages/bslbr/inventory/inventoryDetails';
import DeliverySearch_Br from 'pages/bslbr/inventory/delivery/deliverySearch';
import DeliveryDetails_Br from 'pages/bslbr/inventory/delivery/deliveryDetails/deliveryDetails';
import NewDelivery_Br from 'pages/bslbr/inventory/delivery/newDelivery/newDelivery';
import NewGuia_Br from 'pages/bslbr/inventory/delivery/newDelivery/newGuia';
import ContractReport_Br from 'pages/bslbr/contracts/contractReport';
import Repair_Br from 'pages/bslbr/repair/execute-repair/executeRepair';
import PendingItems_Br from 'pages/bslbr/inventory/delivery/pendingItems/pendingItems';

export type rootType = {
    path: string;
    element?: JSX.Element;
    protected?: boolean;
    name?: string;
    permissions?: IPermissionValidator[];
    children?: (rootType | leafType)[];
};

export type leafType = Omit<rootType, 'children'>;

const routes: rootType[] = [
    { path: '*', name: 'error' },
    {
        path: '/',
        element: <HomePage />,
        protected: false,
        name: 'Home',
        children: [
            {
                path: 'info',
                children: [
                    {
                        path: 'repair-center',
                        element: <RepairCenterPage />,
                        protected: false,
                        name: 'repairCenter'
                    },
                    {
                        path: 'spare-parts',
                        element: <SparePartsPage />,
                        protected: false,
                        name: 'spareParts'
                    },
                    {
                        path: 'certified',
                        element: <CertifiedPage />,
                        protected: false,
                        name: 'certified'
                    },
                    {
                        path: 'solutions',
                        element: <SolutionsPage />,
                        protected: false,
                        name: 'solutions'
                    },
                    {
                        path: 'contact',
                        element: <ContactPage />,
                        protected: false,
                        name: 'contact'
                    },
                    {
                        path: 'contract',
                        element: <ContractsPage />,
                        protected: false,
                        name: 'contracts'
                    },
                    {
                        path: 'instructions',
                        element: <InstructionsPage />,
                        protected: false,
                        name: 'instructions'
                    }
                ]
            },
            {
                path: 'bsl',
                element: <HslPage />,
                protected: true,
                name: 'bsl',
                permissions: [new ModulePermissionValidator(UserModule.HSL_WEB)],
                children: [
                    {
                        path: 'inventory-details/:id',
                        element: <InventoryDetails />,
                        protected: true,
                        name: 'inventoryDetails'
                    },
                    {
                        path: 'pending-items',
                        element: <PendingItems />,
                        protected: true,
                        name: 'pendingItems'
                    },
                    {
                        path: 'delivery',
                        element: <DeliverySearch />,
                        protected: true,
                        name: 'delivery',
                        children: [
                            {
                                path: 'delivery-details',
                                element: <DeliveryDetails />,
                                protected: true,
                                name: 'deliveryDetails'
                            },
                            {
                                path: 'new-delivery',
                                element: <NewDelivery />,
                                protected: true,
                                name: 'newDelivery'
                            },
                            {
                                path: 'new-guia',
                                element: <NewGuia />,
                                protected: true,
                                name: 'newGuia'
                            }
                        ]
                    },
                    {
                        path: 'repair/:id',
                        element: <Repair />,
                        protected: true,
                        name: 'repair'
                    }
                ]
            },

            {
                path: 'bslbr',
                element: <BslbrPage />,
                protected: true,
                name: 'bslbr',
                permissions: [new ModulePermissionValidator(UserModule.HSL_WEB)],
                children: [
                    {
                        path: 'inventory-details/:id',
                        element: <InventoryDetails_Br />,
                        protected: true,
                        name: 'inventoryDetails'
                    },
                    {
                        path: 'pending-items',
                        element: <PendingItems_Br />,
                        protected: true,
                        name: 'pendingItems'
                    },
                    {
                        path: 'delivery',
                        element: <DeliverySearch_Br />,
                        protected: true,
                        name: 'delivery',
                        children: [
                            {
                                path: 'delivery-details',
                                element: <DeliveryDetails_Br />,
                                protected: true,
                                name: 'deliveryDetails'
                            },
                            {
                                path: 'new-delivery',
                                element: <NewDelivery_Br />,
                                protected: true,
                                name: 'newDelivery'
                            },
                            {
                                path: 'new-guia',
                                element: <NewGuia_Br />,
                                protected: true,
                                name: 'newGuia'
                            }
                        ]
                    },
                    {
                        path: 'repair/:id',
                        element: <Repair_Br />,
                        protected: true,
                        name: 'repair'
                    }
                ]
            },

            {
                path: 'repair-center',
                element: <RepairCenter />,
                protected: true,
                name: 'repairCenter',
                permissions: [new ModulePermissionValidator(UserModule.RMA)],
                children: [
                    {
                        path: 'new-rma',
                        element: <NewRma />,
                        protected: true,
                        name: 'newRma',
                        children: [
                            {
                                path: 'details',
                                element: <DetailsRma />,
                                protected: true,
                                name: 'rmaDetails',
                                children: [
                                    {
                                        path: 'summary',
                                        element: <NewRmaSummary />,
                                        protected: true,
                                        name: 'summary'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'rma-detail/:id',
                        element: <RmaDetails />,
                        protected: true,
                        name: 'rmaDetails',
                        children: [
                            {
                                path: 'budget',
                                element: <SendOrderBudget />,
                                protected: true,
                                name: 'budget'
                            }
                        ]
                    }
                ]
            },
            {
                path: 'rma-manufatura',
                element: <RmaManufatura />,
                protected: true,
                name: 'Manufacturing',
                permissions: [new ModulePermissionValidator(UserModule.RMAMANUFATURA)],
                children: [
                    {
                        path: 'new-rma',
                        element: <NewRmaManufatura />,
                        protected: true,
                        name: 'newRma',
                        children: [
                            {
                                path: 'summaryManufacturing',
                                element: <NewRmaSummaryManufatura />,
                                protected: true,
                                name: 'SummaryManufacturing'
                            }
                        ]
                    },
                    {
                        path: 'rmaManufacturing-detail/:id',
                        element: <RmaManufaturaDetails />,
                        protected: true,
                        name: 'rmaManufacturingDetails',
                        children: [
                            {
                                path: 'budget',
                                element: <SendOrderBudgetManufatura />,
                                protected: true,
                                name: 'budget'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: 'spare-parts',
        element: <SpareParts />,
        protected: true,
        name: 'spareParts',
        permissions: [new ModulePermissionValidator(UserModule.SPAREPARTS)],
        children: [
            {
                path: 'chat',
                element: <SparePartsChat />,
                protected: true,
                name: 'spareParts',
                permissions: [new ModulePermissionValidator(UserModule.SPAREPARTS)]
            },
            {
                path: 'order',
                element: <OrdersDetailSelected />,
                protected: true,
                name: 'order',
                permissions: [new ModulePermissionValidator(UserModule.SPAREPARTS)]
            },
            {
                path: 'cart',
                element: <ShoppingCart />,
                protected: true,
                name: 'shipping',
                permissions: [new ModulePermissionValidator(UserModule.SPAREPARTS)]
            }
        ]
    },
    {
        path: 'user',
        element: <UserManager />,
        protected: true,
        name: 'userManager',
        permissions: [new ModulePermissionValidator(UserModule.USER)],

        children: [
            {
                path: 'company',
                element: <CompanyManager />,
                protected: true,
                name: 'companyManager',
                permissions: [new ModulePermissionValidator(UserModule.USER)]
            },
            {
                path: 'customer',
                element: <FinalCustomerManager />,
                protected: true,
                name: 'customerManager',
                permissions: [new ModulePermissionValidator(UserModule.USER)]
            },
            {
                path: 'new-company',
                element: <NewCompany />,
                protected: true,
                name: 'newCompany',
                permissions: [new ModulePermissionValidator(UserModule.USER)]
            }
        ]
    },
    {
        path: 'monitor',
        element: <SystemManager />,
        //protected: true,
        name: 'systemManager'
        //permissions: [new ModulePermissionValidator(UserModule.SYSTEM)]
    },
    {
        path: 'maintenance-report',
        element: <MaintenanceReportPage />,
        protected: true,
        name: 'maintenanceReport',
        permissions: [new ModulePermissionValidator(UserModule.MAINTENANCE_REPORT)],
        children: [
            {
                path: 'report',
                element: <MaintenanceReportDetails />,
                protected: true,
                name: 'report',
                permissions: [new ModulePermissionValidator(UserModule.MAINTENANCE_REPORT)]
            },
            {
                path: 'new-report',
                element: <NewMaintenanceReport />,
                protected: true,
                name: 'report',
                permissions: [new ModulePermissionValidator(UserModule.MAINTENANCE_REPORT)]
            }
        ]
    },
    {
        path: 'warranty-consult',
        element: <WarrantyConsultPage />,
        protected: false,
        name: 'warrantyConsult'
    },
    {
        path: 'find-assistance',
        element: <FindAnAssistancePage />,
        protected: false,
        name: 'findAssistance'
    },
    {
        path: 'dashboard',
        element: <DashboardMenu />,
        protected: true,
        name: 'dashboard'
    },
    {
        path: 'manual',
        element: <TesteManual />,
        protected: false,
        name: 'help'
    },
    {
        path: 'overview',
        element: <Overview />,
        protected: false,
        name: 'overview'
    }
];

export default routes;
